import React, { useEffect } from "react";
import { DashboardIntro } from "../components/Dashboard/DashboardIntro";
import { DashboardSummary } from "../components/Dashboard/DashboardSummary";
import { useNavigate } from "react-router-dom";
import { fetchUserProfile } from "../services/newUserService";
import { handleErrors } from "../utils/errorHandler";
import "../components/Dashboard/dashboard.css";

export const DashboardPage = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const fetchUserData = async () => {
      try {
        await fetchUserProfile();
      } catch (error) {
        handleErrors(error);
      }
    };

    fetchUserData();
  }, [navigate]);

  return (
    <div className="main-content">
      <div className="page-content">
        <div className="container-fluid xc-dashboard">
          <DashboardIntro />
          <DashboardSummary />
        </div>
      </div>
    </div>
  );
};
